import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { LazyLoadEvent, CheckboxModule, InputTextareaModule } from 'primeng';
import { IInspectionType } from '../../interfaces/inspection-type';
import { IInspectionTypeFilter } from '../../interfaces/inspection-type-filter';
import { NoEmptyString } from '../../interfaces/no-empty-string.validator';
import { IPageResult } from '../../interfaces/page-result';
import { InspectionTypeService } from '../../services';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'inspection-types',
  templateUrl: './manage-inspection-type.component.html',
})
export class InspectionTypesComponent implements OnInit {
  public page: IPageResult<IInspectionType> = {
    items: [],
    total: 0,
  };

  public event: any;
  public filter: Subject<IInspectionTypeFilter>;
  public filterVal: IInspectionTypeFilter;
  public isLoaded: boolean = false;
  public displayDialog: boolean = false;
  public inspection: IInspectionType;
  public newinspection: boolean = false;
  public filterString: string;
  public newInspectionTypeForm: UntypedFormGroup;
  public name: UntypedFormControl;
  public description: UntypedFormControl;
  public isActive: UntypedFormControl;
  public selectedItem: any;

  constructor(private inspectionTypeService: InspectionTypeService) {}

  ngOnInit() {
    this.initDefaultFilter();
    this.filter = new Subject<IInspectionTypeFilter>();

    // subscribe to filter changes with a debounce time
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });

    // set default filter
    this.filter.next(this.filterVal);

    // set formGroup instance
    this.name = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(255), NoEmptyString]),
    );
    this.description = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(255), NoEmptyString]),
    );
    this.isActive = new UntypedFormControl(true, Validators.required);

    this.newInspectionTypeForm = new UntypedFormGroup({
      name: this.name,
      description: this.description,
      isActive: this.isActive,
    });
  }

  load(filter: IInspectionTypeFilter) {
    this.inspectionTypeService.getPage(filter).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
    });
  }

  showDialogToAdd() {
    this.newinspection = true;
    this.inspection = {
      name: '',
      description: '',
      id: 0,
      isActive: true,
    };
    this.resetFormValues(this.inspection);
    this.displayDialog = true;
  }

  save(formValues) {
    this.inspection.name = formValues.name.trim();
    this.inspection.description = formValues.description;
    this.inspection.isActive = formValues.isActive;
    if (this.inspection.name !== '') {
      this.inspectionTypeService.create(this.inspection).then((res) => this.load(this.filterVal));
    }
    this.displayDialog = false;
  }

  close() {
    this.displayDialog = false;
  }

  resetFormValues(formValues) {
    this.newInspectionTypeForm.setValue({
      name: formValues.name,
      description: formValues.description,
      isActive: formValues.isActive,
    });
  }

  onRowSelect(event) {
    this.event = event;
  }

  onRowDblclick(item) {
    this.newinspection = false;
    this.inspection = this.cloneInspection(item);
    this.resetFormValues(this.inspection);
    this.displayDialog = true;
  }

  onEdit() {
    if (this.event !== undefined) {
      this.onRowDblclick(this.event);
    }
  }

  cloneInspection(c: IInspectionType): IInspectionType {
    let inspection = { id: 0, name: '', description: '', isActive: true };
    for (let prop in c) {
      inspection[prop] = c[prop];
    }
    return inspection;
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    // map grid lazy load event to filter
    //var eventString = JSON.stringify(event);
    //if (eventString === this.filterString) return;
    //console.log(event);
    //this.filter.next(flatten(event));

    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;

    this.filter.next(this.filterVal);
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: 'Name', // ASC
      sortOrder: 1,
      filters: {
        name: {},
        description: {},
        isActive: {},
      },
    };
  }

  clearFilter(table: any) {
    table.sortField = '';
    this.initDefaultFilter();
    this.filter.next(this.filterVal);
  }

  search() {
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    console.log(this.filterVal);
    this.filter.next(this.filterVal);
  }
}
